module.exports = __webpack_public_path__ + "img/bolala.d3bc71da.jpeg";